import * as actionTypes from 'redux/actions'

const initialState = {
  search: '',
  startDate: new Date('2020-06-08'),
  endDate: new Date('2022-07-08'),
  updateCampaigns: 0
  // or Date.now() + 7 * 24 * 60 * 60 * 1000
}

const creditcardsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CAMPAIGNS_START_DATE: {
      return {
        ...state,
        startDate: action.payload
      }
    }
    case actionTypes.CAMPAIGNS_END_DATE: {
      return {
        ...state,
        endDate: action.payload
      }
    }
    case actionTypes.SEARCH: {
      return {
        ...state,
        search: action.payload
      }
    }
    case actionTypes.UPDATE_CAMPAIGNS: {
      return {
        ...state,
        updateCampaigns: state.updateCampaigns + 1
      }
    }
    default: {
      return state
    }
  }
}

export default creditcardsReducer
